import api from '@/core/services/api';
import { toDrupalRequest } from '@/core/helpers';

export default {
    setSelectedStep({ commit }, payload) {
        commit('setSelectedStep', payload);
    },
    setInvestNowProvider({ commit }, provider) {
        commit('setInvestNowProvider', provider);
    },
    resetStepper({ commit }, steppers) {
        commit('resetStepper', steppers);
    },
    async markTermsAccepted(_, payload) {
        await api.post(`${toDrupalRequest('/clientdirectory/investmentterms')}`, JSON.stringify(payload), {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    },
};
